import {
  GET,
  POST,
  DELETE,
  PUT
} from '../http'
import * as Types from './types'

export default class EmailRulesGateway {
  getOperationsEmailRule () {
    return GET(Types.OPERATIONS_EMAIL_RULE)
  }

  getParametersEmailRule () {
    return GET(Types.PARAMETERS_EMAIL_RULE)
  }

  getEmailRuleList () {
    return GET(Types.GET_LIST_EMAIL_RULE)
  }

  getEmailRule (params = {}) {
    return GET(Types.GET_EMAIL_RULE, params)
  }

  createEmailRule (query = {}) {
    return POST(Types.CREATE_EMAIL_RULE, query)
  }

  updateEmailRule (query = {}) {
    return PUT(Types.UPDATE_EMAIL_RULE, query)
  }

  deleteEmailRule (query = {}) {
    return DELETE(Types.DELETE_EMAIL_RULE, query)
  }
}



// WEBPACK FOOTER //
// ./src/api/email-rules/EmailRulesGateway.js